module.exports = __webpack_public_path__ + "static/media/laswerk.8b045fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/laswerk.png
// module id = 381
// module chunks = 0